import React, { useMemo } from "react";
import { Select } from "antd";

import ScheduleTag from "./ScheduleTag";
import { buildScheduleTagOptions } from "./scheduleTagOptions";

const EMPTY_TAG_VALUES = [];

const ScheduleTagSelect = ({ value = EMPTY_TAG_VALUES, onChange, definitions, definitionMap, isLoading, loadError }) => {
    const selectedTags = Array.isArray(value) ? value : EMPTY_TAG_VALUES;
    const options = useMemo(
        () => buildScheduleTagOptions(definitions, selectedTags),
        [definitions, selectedTags],
    );
    const selectedKeys = useMemo(
        () => new Set(selectedTags.map((tagName) => String(tagName).trim().toLocaleLowerCase())),
        [selectedTags],
    );
    const availableOptions = useMemo(
        () => options.filter((option) => !selectedKeys.has(option.value.toLocaleLowerCase())),
        [options, selectedKeys],
    );

    return (
        <Select
            mode="multiple"
            value={selectedTags}
            onChange={onChange}
            placeholder="请选择标签"
            aria-label="计划标签"
            style={{ width: "100%" }}
            loading={isLoading}
            options={availableOptions}
            optionRender={(option) => (
                <ScheduleTag name={option.value} definitionMap={definitionMap} loadError={loadError} />
            )}
            tagRender={({ value: tagName, closable, onClose }) => (
                <ScheduleTag
                    name={tagName}
                    definitionMap={definitionMap}
                    loadError={loadError}
                    closable={closable}
                    onClose={onClose}
                    onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    style={{ marginBottom: 0 }}
                />
            )}
        />
    );
};

export default ScheduleTagSelect;
